import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';

interface SupportDropdownTextEditorProps {
    element: any
}

const SupportDropdownTextEditor: React.FC<SupportDropdownTextEditorProps> = (element) => {
    
    return (
      <>
        <div className="spacer-top support-text-editor">
          {element?.element?.Content.replace(/^<p>|<\/p>$/g, "").startsWith("https://www.youtube.com") ?
          <p className="youtube-wrap mx-sm-5 mx-0">
            <iframe width="500" height="281" src={element?.element?.Content.replace(/^<p>|<\/p>$/g, "")} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </p>
          : 
          <>
            <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{element?.element?.Content}</ReactMarkdown>
            {element?.element?.ButtonLink && element?.element?.ButtonText ? 
            <p className="text-center">
              <a href={element?.element?.ButtonLink} className="default-btn mx-auto" target="_blank">{element?.element?.ButtonText}</a>
            </p>
            :<></> }
          </>}
        </div>
      </>
    );
};

export default SupportDropdownTextEditor;